import { filter } from 'lodash';

export const casecmp = (value1, value2) => value1.localeCompare(value2, 'en', { sensitivity: 'accent' });
export const isBlank = value => value == null || value === '';
export const isPresent = value => value != null && value !== '' && value !== '--';
export const presentValueOrDefault = (value, defaultValue) => isPresent(value) ? value : defaultValue;
export const valueOrPlaceholder = value => value || '--';

export const getInitials = (name) => {
  let initials = '?';

  if (isPresent(name)) {
    const names = filter(name.split(' '), isPresent);

    if (names.length > 1) {
      initials = names[0][0] + names[names.length - 1][0];
    } else if (names.length === 1) {
      initials = names[0][0];
    }
    initials = initials.toUpperCase();
  }

  return initials;
};
